import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

export const FullLoading = ({ loadingState }) => {
	const renderComponent = () => {
		return (
			<div className='flex h-full w-full absolute z-50 bg-white opacity-80 justify-center content-center items-center flex-col'>
				<ProgressSpinner mode='indeterminate' className='flex w-full h-8 ' />
			</div>
		);
	};

	const show = loadingState;

	//const show = true;

	return <>{show ? renderComponent() : null}</>;
};
